export default __webpack_public_path__ + "static/media/jobEmpty.a8f75adf.svg";